import '../../assets/components/ProductDetails/productDetails.css';const t = "_productDetailsInfo_3qh62_1", o = {
  productDetailsInfo: t
};
export {
  o as default,
  t as productDetailsInfo
};
